import { useState } from "react";
import {
  isDatasheetPage,
  isProductPage,
  userOnMyAccountPage,
  userOnRegistrationConfirmatioAccountPage,
  userOnRegistrationConfirmationEmailPage,
} from "~/utils/url/urlUtils";
import {
  displayAffiliatePartnerPopupBanner,
  saveAffiliatePopupClosedCookie,
  showAffiliatePopupBanner,
} from "~/domains/affiliate/utils/utils";
import { useOnMount } from "~/common/hooks/useOnMount";
import { trackAffiliatePopupLoad } from "~/app/analytics/ga/affiliate";
import Modal from "~/common/components/Modal";
import { MediasLogo } from "~/features/navigation/components/TopBar/MediasLogo";
import { CompanyLogo } from "~/domains/company/components/CompanyLogo";
import { Card } from "~/features/configurator/Linear/components/Card";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";

import classes from "~/features/affiliate/components/AffiliateSalesPartnerPopup/AffiliateSalesPartnerPopup.module.less";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/mui";
import { selectVisitedAffiliate } from "~/domains/affiliate/redux/selectors";
import { useSelector } from "react-redux";
import { trackAffiliateCADRedirect } from "~/app/analytics/ga/ga";
import { ProductService } from "~/features/addToCart/api/ProductService";

export const AffiliateSalesPartnerPopup = () => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState<boolean>(showAffiliatePopupBanner());

  const partner = useSelector(selectVisitedAffiliate);

  const isDatasheet = isDatasheetPage();

  useOnMount(() => {
    if (partner && isOpen) {
      trackAffiliatePopupLoad(partner?.name ?? "");
    }
  });

  const isMinDesktop = useIsMinDesktopSize();

  if (!isOpen || isDatasheet) {
    return null;
  }

  const onClose = () => {
    const isPdp = isProductPage();
    setIsOpen(false);
    saveAffiliatePopupClosedCookie();
    if (isPdp && partner) {
      const productCode = window.location.pathname.split("/p/")[1];
      const productData = ProductService.getBaseProductData(productCode);
      trackAffiliateCADRedirect(
        productData?.designation ?? "",
        productData?.code ?? "",
        partner.name,
        partner.affiliateId,
      );
    }
  };

  return (
    <Modal
      onClose={onClose}
      footerChildren={
        <Button fullWidth={!isMinDesktop} onClick={onClose} data-test-id={"close-modal-partner"}>
          {t("generic.ok")}
        </Button>
      }
    >
      <div className={"d-flex flex-justify-between scha__header-element mt-2 pb-3 mb-30"}>
        <MediasLogo variant={"general"} />
        <CompanyLogo className={"scha__header__logo"} />
      </div>
      <h3 className={"mb-2 headline-small"}>{t("tour.1.banner.title")}</h3>
      <p className={"mb-30 title-medium()"}>{t("affiliateSalesPartner.popup.redirect")}</p>
      <Card disableHover={true} className={classNames(classes.affiliateCard)}>
        {partner?.logo && <img src={partner.logo} className={classes.logo} />}
        {partner?.logo && <div className={classes.separator} />}
        <p className={"title-medium() m-0 f-bold py-3"}>{partner?.name}</p>
      </Card>
    </Modal>
  );
};

export function createAffiliateSalesPartnerPopup() {
  // guard
  if (!displayAffiliatePartnerPopupBanner()) {
    return;
  }
  if (
    userOnRegistrationConfirmationEmailPage() ||
    userOnRegistrationConfirmatioAccountPage() ||
    userOnMyAccountPage()
  ) {
    return null;
  }
  return <AffiliateSalesPartnerPopup />;
}
